/* tslint:disable */
/* eslint-disable */
export enum SupplierContactLogMethod {
    Redirect = 'REDIRECT',
    Email = 'EMAIL',
    Link = 'LINK'
}
